export default "__VITE_ASSET__8clSNRPE__"